import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconClose.module.css';
const SIZE_SMALL = 'small';

const IconClose = props => {
  const { className, rootClassName, size } = props;
  const classes = classNames(rootClassName || css.root, className);

  if (size === SIZE_SMALL) {
    return (
      <svg
        className={classes}
        width="8"
        height="8"
        viewBox="0 0 28 28"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1.293 1.293a1 1 0 0 1 1.32-.083l.094.083 24 24a1 1 0 0 1-1.32 1.497l-.094-.083-24-24a1 1 0 0 1 0-1.414" />
        <path d="M26.707 1.293a1 1 0 0 0-1.32-.083l-.094.083-24 24a1 1 0 0 0 1.32 1.497l.094-.083 24-24a1 1 0 0 0 0-1.414" />
      </svg>
    );
  }

  return (
    <svg
      className={classes}
      width="14"
      height="14"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1.293 1.293a1 1 0 0 1 1.32-.083l.094.083 24 24a1 1 0 0 1-1.32 1.497l-.094-.083-24-24a1 1 0 0 1 0-1.414" />
      <path d="M26.707 1.293a1 1 0 0 0-1.32-.083l-.094.083-24 24a1 1 0 0 0 1.32 1.497l.094-.083 24-24a1 1 0 0 0 0-1.414" />
    </svg>
  );
};

const { string } = PropTypes;

IconClose.defaultProps = {
  className: null,
  rootClassName: null,
};

IconClose.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconClose;
